import { Component, OnInit, Input, QueryList, ViewChildren, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TenderQuantityService } from 'src/app/Service/tender-quantity/tender-quantity.service';
import { TenderQuantityAddDataComponent } from '../tender-quantity-add-data/tender-quantity-add-data.component';

@Component({
  selector: 'app-tender-quantity',
  templateUrl: './tender-quantity.component.html',
  styleUrls: ['./tender-quantity.component.css']
})
export class TenderQuantityComponent implements OnInit {
  public elementList: any[] = [];
  public ItemsList: any[] = [];
  public DiscElementItemList: any[] = [];
  public suggestionValue :  any[] = []; 
  public enableElementFilter = false;
  public enableitemFilter = false;
  public enableconfigureFilter = false;
  public configureValue : any| any[] =[];
  constructor(private dialog: MatDialog, private tenderQuantityService: TenderQuantityService) {
  }


  ngOnInit() {
    this.getData();
  }


  getData() {
    this.tenderQuantityService.getElementDataToDp().subscribe(data => {         
      this.elementList = data;    
      this.elementList.forEach((value,i)=>{ 
        value["index"] = i+1;
        if(value.active_Tag =="Y"){
          value.active_status = "Yes"; 
         }else{
          value.active_status = "No";
         }
        });
    });
    this.tenderQuantityService.getItemDataToDp().subscribe(data => {
      this.ItemsList = data;  
      this.ItemsList.forEach((value,i)=>{ 
        value["index"] = i+1;
        if(value.active_Tag =="Y"){
          value.active_status = "Yes"; 
         }else{
          value.active_status = "No";
         }
    });
          
    })
    this.tenderQuantityService.getDiscElementItemData().subscribe(data => {
      this.DiscElementItemList = data;
      this.DiscElementItemList.forEach((value,i)=>{ 
        value["index"] = i+1;
        if(value.active_Tag =="Y"){
          value.active_status = "Yes";  
         }else{
          value.active_status = "No";
         }
        });       
    });
  }

  AddNewData(currentpage?:String,val?: any ,state?:any) {
    switch (currentpage){
      case 'element' :{
        this.suggestionValue = this.elementList;
        break;
      }
      case 'items' :{
        this.suggestionValue = this.ItemsList;
        break;
      }
      default :{          
        this.elementList = this.elementList.filter(data=>data.active_Tag == "Y");
        this.ItemsList = this.ItemsList.filter(data=>data.active_Tag == "Y");       
        this.configureValue["elementList"] = this.elementList;
        this.configureValue["ItemsList"] = this.ItemsList;
        break;
      }
    }
    let typeAction = {
      "value":val,
      "currentpage":currentpage,
      "existData" :this.suggestionValue,
      "configureValue" : this.configureValue,
      "state":state
    }   
    let dialogRef = this.dialog.open(TenderQuantityAddDataComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '60%',
      maxWidth: '60vw',
      data: typeAction
    });
    dialogRef.afterClosed().subscribe(data => {
      this.getData();
    });
  } 

  editHandler(currentpage:string,val:any,) {
    let state="edit";
    this.AddNewData(currentpage,val,state);
  }

  toggleFilter(tap:any) {   
    switch (tap){
      case 'element' :{
        this.enableElementFilter = !this.enableElementFilter;
        break;
      }
      case 'items' :{
        this.enableitemFilter = !this.enableitemFilter;
        break;
      }
      case 'Configure' :{
        this.enableconfigureFilter = !this.enableconfigureFilter;
        break;
      }
    }  
  }

  tabClick(event:any){
    this.enableElementFilter = false;
    this.enableitemFilter = false;
    this.enableconfigureFilter = false;
  }

}




